// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select[data-v-0829bb36]  .el-form-item__content {\n  width: 8em;\n}", ""]);
// Exports
module.exports = exports;
